import { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import API from "../../api";

export default function SupportAnswerPage() {
  const { id } = useParams();
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    API.get("faq")
        .then((res) => {
          const data = res?.data;
          if (Array.isArray(data) && data.length && data[0]?.faqs) setCats(data);
          else setCats([]);
        })
        .finally(() => setLoading(false));
  }, []);

  const all = useMemo(() => cats.flatMap((c) => (c.faqs || []).map((f) => ({ ...f, _catTitle: c.title }))), [cats]);
  const faq = useMemo(() => all.find((f) => String(f.id) === String(id)), [all, id]);

  const qaJsonLd = faq && {
    "@context": "https://schema.org",
    "@type": "QAPage",
    "mainEntity": {
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": { "@type": "Answer", "text": stripHtml(faq.answer || "") }
    }
  };

  return (
      <>
        <Helmet>
          <title>{faq ? `${faq.question} | Support | MyGolfDNA` : "Support | MyGolfDNA"}</title>
          {qaJsonLd && <script type="application/ld+json">{JSON.stringify(qaJsonLd)}</script>}
        </Helmet>

        <section className="py-4">
          <Container>
            {loading ? (
                <div className="text-center py-5"><Spinner animation="border" /></div>
            ) : !faq ? (
                <Alert variant="light" className="border">We couldn’t find that answer.</Alert>
            ) : (
                <article className="mx-auto" style={{ maxWidth: 880 }}>
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="small text-black-50">{faq._catTitle}</div>
                    <div className="d-flex gap-2">
                      <Button as={Link} to={`/support/q/${faq.id}`} variant="outline-primary" size="sm">
                        Open in Drawer
                      </Button>
                      <Button as={Link} to="/support" variant="outline-secondary" size="sm">
                        Back to Support
                      </Button>
                    </div>
                  </div>
                  <h1 className="h3 mb-3">{faq.question}</h1>
                  <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                </article>
            )}
          </Container>
        </section>
      </>
  );
}

function stripHtml(html = "") {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}
